import React, { useState, useEffect } from 'react';
import Card, { CardContent, CardTitle } from "src/MarketDataComponents/Card";
import {Tabs} from '../Tabs';

export default function NewsContent({moreLink, news, setSelectedIndex, selectedIndex}) {
    const [newsTabsProps, setNewsTabsProps] = useState(null);

    useEffect(() => {
        let newsTabsProps = {
			tabs: [],
            selectedTabIndex: selectedIndex,
            changeSelected: setSelectedIndex
		}

		news.map(item => {
			newsTabsProps.tabs.push({
				label: item.title,
				content: tabContent(item.newsItems)
			});
		});

        setNewsTabsProps(newsTabsProps);
    }, [news]);

    const NewsItem = ({href, title, tags, date, summary}) => {
        return <Card extraClassnames="ajb-inset-squish--m">
            <CardContent>
                <CardTitle tag="p" size="s">
                    <a href={href}>
                        <b>{title}</b>
                    </a>
                </CardTitle>

                {summary !== undefined && <p>{summary}</p>}
                
                <p>
                    <small>
                        {tags !== undefined && tags.length > 0 &&
                            tags.map( (item, i) => {
                                if ( item.href !== undefined ) {
                                    return (
                                        <React.Fragment key={i}><i className="fa fa-newspaper-o h7" aria-hidden="true"></i> <a href={item.href}>{item.title}</a> | </React.Fragment>
                                    );
                                } else {
                                    return <React.Fragment key={i}>{item.title} | </React.Fragment>;
                                }
                            })
                        }
                        <span className="light-text">{date}</span>
                    </small>
                </p>
            </CardContent>
            <hr />
        </Card>
    }

    const tabContent = (newsItems) => ( 
        <>
            {newsItems.map((item, i) => (
                <React.Fragment key={i}>
                    <NewsItem {...item} />
                </React.Fragment>
            ))}
            {moreLink ? <p className="margin-bottom-0 margin-left-20"><a href={moreLink} data-testid="moreNewsLink">More...</a></p> : null}
            <hr />
        </>
    );

    return newsTabsProps ? <Tabs {...newsTabsProps} /> : null
}